<!-- 由 suu 创建于 2022-01-18 星期二 -->
<template>
  <div class="recipe-result">
    <div class="result-container" v-if="questionResult">
      <div class="container-padding">
        <div class="banner-top">
          <div>@明星减脂营营养研究所</div>
          <div>{{ questionResult.add_time }}</div>
        </div>
        <div class="serial-number">{{ questionResult.number }}</div>
        <div class="nutrition-title">
          <div>
            <div class="nutrition-text">营养评估方案</div>
            <div class="desc">国家级专业营养师定制 / 专属于您的饮食方案</div>
          </div>
          <img
            class="stripe-code"
            src="https://cdnvue.gymcity.com.cn/uploads/2e05ca951f78610a95fde14bb32e1cfd.png"
          ></img>
        </div>
        <!--  -->
        <div class="avatar-container">
          <div class="avatar-list">
            <div
              class="avatar-item"
              v-for="(item, index) in questionResult.participation.user_data"
              :key="index"
              :style="{transform: `translateX(-${1.5 * index}vw)`}"
            >
              <img class="avatar-image" :src="item"></img>
            </div>
          </div>
          <div>{{ questionResult.participation.count || 0 }}位用户改善成功</div>
        </div>
        <!-- 用户信息 -->
        <div class="user-info" v-if="questionResult.user">
          <img
            class="private-custom"
            src="https://cdnvue.gymcity.com.cn/uploads/314c1f445198433f6650d1c05a7b1754.png"
          ></img>
          <div class="info-top">
            <img
              class="avatar"
              :src="questionResult.user.head_img"
            ></img>
            <span class="user-name">{{ questionResult.user.name }}</span>
          </div>
          <div class="user-table">
            <div class="table-item">
              <div class="left">性别：{{ questionResult.user.sex }}</div>
              <div class="right">身高：{{ questionResult.user.height }}cm</div>
            </div>
            <div class="table-item">
              <div class="left">年龄：{{ questionResult.user.age }}</div>
              <div class="right">体重：{{ questionResult.user.weight }}kg</div>
            </div>
          </div>
          <div class="line"></div>
          <div class="target">
            <span>目标</span>
            <div class="dash-line"></div>
            <div>{{ questionResult.goal[1] }}</div>
          </div>
          <div class="target-desc">
            <div v-html="questionResult.goal[0]"></div>
          </div>
        </div>
      </div>
      <!-- 切换栏 -->
      <div class="nav-container">
        <div class="nav-list">
          <div :class="['nav-item', curNav == index ? 'nav-item-active' : '']" v-for="(item, index) in navList" :key="index"
           @click="bindNavChange(item, index)">{{item.name}}</div>
        </div>
      </div>
      <div class="container-padding">
         <!-- 我的报告 -->
        <div  class="my-report" id="nav1">
          <div class="v-flag">报告</div>
          <div class="report-title">
            <div>我的报告</div>
            <div class="shadow"></div>
          </div>
          <!-- bmi指数 -->
          <div class="report-item" v-if="questionResult.bmi">
            <div class="title-upline-top">
              <div class="title-text">身体质量指数(BMI)</div>
              <div class="dashed-line"></div>
              <div class="score">{{questionResult.bmi.value}}</div>
            </div>
            <v-bmi :bmi="questionResult.bmi.value"></v-bmi>
            <div class="bmi-desc">{{questionResult.bmi.describe}}</div>
          </div>
          <!-- 生活习惯 -->
          <div class="report-item">
            <div class="title-upline-top">
              <div class="title-text">生活习惯</div>
              <div class="dashed-line"></div>
              <div class="score">良好</div>
            </div>
            <div class="habit-list">
              <div class="habit-item" v-for="(value, key, index) in questionResult.life_style.data" :key="index">
                <div class="left">
                  <i class="icon iconfont" :class="[iconObj[key]]"></i>
                  <div class="habit-item-center">
                    <div>{{key}}</div>
                  </div>
                </div>
                <div class="right">
                  <div>{{value}}</div>
                  <div class="allergy-tips" v-if="key == '过敏原'">（营养方案中已进行脱敏处理）</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 营养风险 -->
          <div class="report-item">
            <div class="title-upline-top">
              <div class="title-text">营养风险</div>
              <div class="dashed-line"></div>
              <div class="score">中</div>
            </div>
            <div class="nutrition-table">
              <div class="vertical-line-list">
                <div class="vertical-line-item" v-for="(item, index) in 4" :key="index" :style="{left: `${(70 + 122 * (index + 1))/ 750 * 100}vw`, 'opacity': `${1 - index * 0.1}`}"></div>
              </div>
              <!-- 过量 适中 不足-->
              <div class="nutrition-table-item" v-for="(value, key, index) in nutritionList" :key="key" v-if="questionResult.nutritional_risk.data[key].length">
                <div class="nutrition-left">
                  <div class="left-dot" :style="{backgroundColor: `${value.color}`}"></div>
                  <div class="left-text">{{value.desc}}</div>
                </div>
                <div class="nutrition-right" :style="{backgroundImage: `linear-gradient(90deg,${value.startColor} 0,#fff 25%)`}">
                  <div :class="['nutrition-tag-item', value.size]" v-for="(item1, index1) in questionResult.nutritional_risk.data[key]" :key="index1" :style="{margin: `${_randomMargin(70,60,questionResult.nutritional_risk.data[key].length)}`}">{{item1}}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 综合诊断 -->
          <div class="report-item">
            <div class="diagnosis-content">
              <div class="title">综合诊断</div>
              <div class="desc">饮食生活、运动习惯、休息睡眠与个人健康有着极其密切的关系，不健康的减脂方式更有可能对身体造成不可逆的伤害。摒弃不良生活习惯搭配合理的饮食方案可帮助身体改善营养状况，增强身体素质。</div>
              <!-- <image class="code" src="https://cdnvue.gymcity.com.cn/uploads/2dd7fdf0413348f630da8eb3fffc52b8.jpg"></image>
              <div class="tips">
                <text>扫码添加客服，获取详细的报告解答</text>
                <div class="circle"></div>
              </div> -->
            </div>
          </div>
          <!-- 营养师有话说 -->
          <div class="report-item">
            <div class="blue-line"></div>
            <div class="say-title">营养师有话说</div>
            <div class="say-content">
              <div class="say-top">
                <div class="coach-info" v-if="questionResult.dietician">
                  <img class="coach-avatar" :src="questionResult.dietician.url"></img>
                  <div class="coach-name">{{questionResult.dietician.name}}</div>
                </div>
                <div class="coach-desc">
                  <div class="coach-desc-item"v-for="(item, index) in questionResult.dietician.card" :key="index">{{item}}</div>
                </div>
              </div>
              <div :class="['say-text', isOpen ? '' : 'limit-text']">
                <div class="say-text-item">亲爱的用户！我是本次为您定制方案的营养师{{questionResult.dietician.name}}，根据您的生活习惯分析，建议您：</div>
                <div class="say-text-item"v-for="(item, index) in questionResult.hjjsw" :key="index">
                  <div class="say-text-title">{{index + 1}}、{{item.title}}</div>
                  <div>{{item.describe}}</div>
                </div>
              </div>
              <div class="open">
                <div class="say-open" @click="isOpen = !isOpen">{{isOpen ? '收起' : '展开'}}
                  <van-icon :name="`arrow-${isOpen ? 'up' : 'down'}`" />  
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 营养方案 -->
        <div class="nutrition-plan" id="nav2">
          <div class="v-flag flag-pink">方案</div>
          <div class="report-title">
            <div>营养评估方案</div>
            <div class="nutrition-plan-desc">营养全餐，轻松控卡</div>
            <div class="shadow"></div>
          </div>
          <v-tabs class="day-nav-list" :tabs="dayList" :activeTab="curDay" @tabclick="changeDay"></v-tabs>
          <div class="food-content">
            <!-- 每日的食谱 -->
            <div class="content-list" v-for="(mealitem, mealindex) in questionResult.cookbook[curDay].list" :key="mealindex">
              <div :class="['meal-type', 'meal-type-' + mealindex]">
                <div class="meal-text">{{mealitem.title}}</div>
                <div>{{mealitem.range}}</div>
              </div>
              <div class="meal-list">
                <div class="meal-item" v-for="(foodtypeitem, foodtypeindex) in mealitem.food" :key="foodtypeindex">
                  <div class="food-type">{{foodtypeitem.type_name}}</div>
                  <div class="food-right">
                    <div class="food-right-content flex"
                      v-if="foodtypeitem.type == 'protein' && foodtypeitem.data.length > 1">
                      <div class="food-list">
                        <div class="food-item" v-for="(fooditem, foodindex) in foodtypeitem.data" :key="foodindex">{{fooditem.name}}({{fooditem.weight}}g)</div>
                      </div>
                      <div class="food-flex-1">
                        <div class="food-add-icon"
                          v-if="foodtypeitem.data.length > 1 && foodtypeitem.type == 'protein'">
                          <div class="food-left-content">
                            <div class="food-add-item" v-for="(fooditem, foodindex) in foodtypeitem.data.length - 1" :key="foodindex"></div>
                          </div>
                          <div class="food-right-line"></div>
                        </div>
                        <div class="food-line-icon" v-else>
                          <div class="food-add-item" v-for="(fooditem, foodindex) in foodtypeitem.data.length" :key="foodindex"></div>
                        </div>
                      </div>
                      <div class="food-unit">{{foodtypeitem.data[0].units}} ({{foodtypeitem.sum_weight}}g)</div>
                    </div>
                    <!--  -->
                    <div class="food-right-content" v-else>
                      <div class="food-item"v-for="(fooditem, foodindex) in foodtypeitem.data" :key="foodindex">
                        <div class="food-name">{{fooditem.name}}</div>
                        <div class="food-flex-1">
                          <div class="food-line-icon">
                          </div>
                        </div>
                        <div class="food-unit">{{fooditem.units}} ({{fooditem.weight}}g)</div>
                      </div>
                    </div>
                    <!--  -->
                  </div>
                </div>
              </div>
              <div class="recommend"><span class="recommend-red"
                  v-if="mealitem.menu">*推荐菜:</span><span>{{mealitem.menu}}</span></div>
            </div>
            <div class="food-tips">*本食谱所有克数代表生重，一拳一掌代表熟重</div>
          </div>
          <!-- 喝水 -->
          <div class="drink-content">
            <div class="title-upline-top">
              <div class="drink-plan-title">喝水安排</div>
              <div class="water-ml">
                <img class="cup-image" mode="heightFix"
                  src="https://cdnvue.gymcity.com.cn/uploads/ceb109cec435260736892a8d1383f92c.png"></img>
                <text>一杯水大概200-250ml</text>
              </div>
            </div>
            <div class="drink-day-list">
              <div class="drink-day-item" v-for="(item, index) in drinkPlan" :key="index">
                <div class="drink-time">{{item.type}}</div>
                <div class="dirnk-list">
                  <div class="dirnk-item" v-for="(item1, index1) in item.data" :key="index1">
                    <div class="drink-item-left">{{item1.time}}</div>
                    <div class="drink-item-dashed"></div>
                    <div class="drink-item-right">
                      <img class="cup-image" mode="heightFix"
                        src="https://cdnvue.gymcity.com.cn/uploads/ceb109cec435260736892a8d1383f92c.png"></img>
                      <span class="drink-item-unit">*{{item1.cup}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nitice-container">
            <img class="notice-iamge" mode="widthFix"
              src="https://cdnvue.gymcity.com.cn/uploads/65b11b337b2484b73bf95b963b7960e1.png"></img>
          </div>
        </div>
        <div class="reduce-fat-content">
        <div>
        <!-- 减脂干货 -->
        <div class="top-line"></div>
        <div class="top-content">
          <div class="title">减脂干货</div>
          <div class="desc">减脂路上踩过的坑，你中招了吗？</div>
        </div>
        </div>
        <div class="question-content">
          <img class="question-image" v-if="questionResult.test.image_url"
            :src="questionResult.test.image_url"></img>
          <div class="question-text">{{questionResult.test.question}}</div>
          <div class="btn-list">
            <div :class="['btn-item', curAnswer === item.key ? 'btn-item-active' : '']" @click="selectAnswer(index)"
              v-for="(item, index) in questionResult.test.options" :key="index">
              {{item.key == '0' ? '是' : '不是'}}</div>
          </div>
          <div v-if="showResult">
            <div class="result">
              <span
                :class="['iconfont', curAnswer == questionResult.test.right_key ? 'icon-kaixin' : 'icon-nanguo']"></span>
              <span class="result-text"> {{curAnswer == questionResult.test.right_key ? '恭喜你，答对了!' : '很遗憾答错了!'}}</span>
            </div>
            <div class="line"></div>
            <div>
              <div class="parsing">答案解析</div>
              <div class="parsing-list">
                <div class="parsing-item">
                  <div v-if="questionResult.test.analysis" v-html="questionResult.test.analysis"></div>
                  <!-- <div class="parsing-item-index">1.</div>
                  <div>脂溶性维生素A、D、E、K都藏在牛奶的脂肪中，所以全脂牛奶比脱脂牛奶的营养价值更高</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
       <div class="publicity-container">
      <img class="fat-camp-image" mode="widthFix"
        src="https://cdnvue.gymcity.com.cn/uploads/a59a84f27c61aa7a8c4ce02e4179b1aa.png"></img>
      <div class="publicity-padding">
        <div class="line-title-line">学员案例</div>
        <div class="case-container">
          <div class="swiper-dots">
            <div :class="['swiper-dot-item', curCase == index ? 'swiper-dot-item-active' : '']"
              v-for="(item, index) in caseImageList" :key="index"></div>
          </div>
          <van-swipe class="case-swiper" @change="onCaseChange" :initial-swipe="curCase" :loop="false" :width="224" :show-indicators="false">
            <van-swipe-item class="case-swiper-item" v-for="(item, index) in caseImageList" :key="index">
               <img :src="item"
                :class="['case-image', (curCase + 1) == index ? 'case-image-after' : '', (curCase - 1) == index ? 'case-image-before' : '']">
              </img>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="line-title-line">学员感言</div>
        <!-- 学员感言 -->
        <div class="testimonials-container">
          <div class="swiper-dots">
            <div :class="['swiper-dot-item', curTestimonials == index ? 'swiper-dot-item-active' : '']"
              v-for="(item, index) in curTestimonialsImageList" :key="index"></div>
          </div>
           <van-swipe class="case-swiper" @change="onCurTestimonialsChange" :initial-swipe="curTestimonials" :loop="false" :width="210" :show-indicators="false">
            <van-swipe-item class="case-swiper-item" v-for="(item, index) in curTestimonialsImageList" :key="index">
               <img :src="item"
                :class="['case-image', (curTestimonials + 1) == index ? 'case-image-after' : '', (curTestimonials - 1) == index ? 'case-image-before' : '']">
              </img>
            </van-swipe-item>
          </van-swipe>
        </div>
        <!--  -->
      </div>
    </div>
      <div class="bottom-content">
        <!-- <div class="qrcode-content">
          <image src="https://cdnvue.gymcity.com.cn/uploads/b558d7810e956001d692e430c9e2c4e3.png" class="qrcode-image" mode="aspectFill"></image>
        </div>
        <div class="qrcode-center">
          <div class="iconfont icon-shuangjiantoushang"></div>
          <div>扫码添加客服</div>
          <div>立即获取明星同款营养课程！</div>
        </div> -->
        <div class="feedback-btn" @click="jumpToFeedback">填写使用反馈</div>
        <div class="feedback-text" v-if="s_from !== '兑换码领取(转介)'">
          <span>填写使用反馈，还可领取</span>
          <span class="feedback-tip">50元优惠券</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { drinkPlan } from './data.js'
import VBmi from './ponents/result-bmi.vue'
import VTabs from './ponents/result-tab.vue'
export default {
  name: 'recipe-result',

  components: { VBmi, VTabs },

  props: {},

  data() {
    return {
      drinkPlan,
      navList: [
        {
          id: 'nav1',
          name: '我的报告'
        },
        {
          id: 'nav2',
          name: '营养方案'
        }
      ],
      curNav: 0,
      iconObj: {
        饮食: 'icon-yinshi',
        运动: 'icon-huaban',
        吸烟: 'icon-jiupingkuai',
        饮酒: 'icon-icon_xiyan',
        睡眠: 'icon-shuimian',
        过敏原: 'icon-guominyuan',
        服用药物: 'icon-yaowu',
        服用补剂: 'icon-icon-fuyongbuji'
      },
      nutritionList: {
        excess: {
          desc: '过量',
          color: '#fa5a73',
          startColor: '#FEEDEF',
          tagList: [
            '维A',
            '奶制品',
            '维A',
            '奶制品',
            '维A',
            '奶制品',
            '维A',
            '奶制品'
          ]
        },
        moderation: {
          desc: '适中',
          color: '#6384e8',
          startColor: '#EEF1FC',
          tagList: ['维C', '钙质'],
          size: 'tag-middle',
          line: 1,
          positionArr: [
            { x: 50, y: 50 },
            { x: 200, y: 50 }
          ]
        },
        lack: {
          desc: '不足',
          color: '#979da5',
          startColor: '#F8F8F8',
          tagList: ['维B2', '铁'],
          size: 'tag-small',
          line: 1,
          positionArr: [
            { x: 50, y: 50 },
            { x: 200, y: 50 }
          ]
        }
      },
      caseImageList: [
        'https://cdnvue.gymcity.com.cn/uploads/e3abab27b12fa3325f0c0cc141ff3887.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/77206da699194ad83428915ff8dd3a80.png',
        'https://cdnvue.gymcity.com.cn/uploads/deb0e354eb3631385e7a1db75b5fdbb9.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/11e8b48c9ea60033e5e41642037a7d71.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/36c5e020812836fdf410c2a0e7089195.jpg'
      ],
      curTestimonialsImageList: [
        'https://cdnvue.gymcity.com.cn/uploads/86d87c3b2f9807017d2df5a8c2753f38.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/01577f92fcb14956dd44ff4cf5d6ae05.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/dd0afc9366bdf5cbfc38ba6c3ab35186.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/aa5810638959120e8ac3a6c517b1d506.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/e086730be27c9b9e08028b37bccc0460.jpg'
      ],
      isOpen: false,
      s_from: this.$route.query.s_from,
      id: this.$route.query.id, //营养评估方案id
      dayList: [], // 方案按天tab标题
      curDay: 0,
      curAnswer: '',
      curCase: 0,
      curTestimonials: 0,
      showResult: false, //是否显示答案
      bmi: 22.5,
      feedBackData: [],
      questionResult: null //问卷结果
    }
  },

  computed: {},

  watch: {},

  created() {
    this.getResultData()
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 案例轮播改变
    onCaseChange(i) {
      this.curCase = i
      const ele = document.querySelector('.van-swipe__track')
      if (i == this.caseImageList.length - 1) {
        ele.style.marginLeft = '-60px'
      } else {
        ele.style.marginLeft = '60px'
      }
    },
    // 学员感言轮播改变
    onCurTestimonialsChange(i) {
      this.curTestimonials = i
      const ele = document.querySelectorAll('.van-swipe__track')[1]
      if (i == this.curTestimonialsImageList.length - 1) {
        ele.style.marginLeft = '-60px'
      } else {
        ele.style.marginLeft = '60px'
      }
    },
    //选择答案时
    selectAnswer(key) {
      if (this.showResult) {
        return
      }
      this.$dialog
        .confirm({
          title: '提示',
          message: '确认选择该答案？'
        })
        .then(() => {
          // on confirm
          this.curAnswer = key
          this.showResult = true
        })
        .catch(() => {
          // on cancel
        })
    },
    // 方案日期更改
    changeDay(i) {
      this.curDay = i
    },
    // 获取数据
    getResultData() {
      this.$toast.loading('加载中···')
      this.$http
        .getApp('member/AppCamp/posterDetailV2', {
          rid: this.id
        })
        .then((res) => {
          this.$toast.clear()
          res = res.data
          if (res.code == 200) {
            let dayList = []
            res.data.cookbook.map((item, index) => {
              dayList.push('第' + (index + 1) + '天')
            })
            this.dayList = dayList
            this.feedBackData = res.data.couple_back_data || []
            this.questionResult = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          this.$toast.clear()
        })
    },
    // 切换nav
    bindNavChange(item, i) {
      this.curNav = i
      document.querySelector(`#${item.id}`) &&
        document.querySelector(`#${item.id}`).scrollIntoView(true)
    },
    // 跳转填写反馈
    jumpToFeedback() {
      if (this.feedBackData.length) {
        sessionStorage.setItem(
          'feedbackData',
          JSON.stringify(this.feedBackData)
        )
        this.$router.push(
          `/recipe-feedbackStatus?id=${this.id}&s_from=${this.s_from}`
        )
      } else {
        this.$router.push(
          `/recipe-feedback?id=${this.id}&s_from=${this.s_from}`
        )
      }
    },
    //垂直方向的总外边距  水平方向的总边距 标签个数
    //为了让营养元素的标签看起来更像随机摆放
    _randomMargin(column, row, num) {
      console.log(num)
      var mingap = parseInt(20 / (parseInt(num / 4) || 1))
      column = parseInt(column / (parseInt(num / 4) || 1))
      row = parseInt(row / (parseInt(num / 4) || 1))
      var top = mingap + Math.floor(Math.random() * (column - 2 * mingap))
      var bottom = column - top
      var left = mingap + Math.floor(Math.random() * (row - 2 * mingap))
      var right = row - left
      return (
        (top / 750) * 100 +
        'vw ' +
        (right / 750) * 100 +
        'vw ' +
        (bottom / 750) * 100 +
        'vw ' +
        (left / 750) * 100 +
        'vw'
      )
    }
  }
}
</script>

<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.recipe-result {
  width: 100vw;
  min-height: 100vh;
  .result-container {
    width: 100%;
    padding: vw(40) vw(0) vw(0);
    box-sizing: border-box;
    background-image: url('https://cdnvue.gymcity.com.cn/uploads/f17d592f214d281f55feda56dc91f6ab.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: top center;
    background-color: rgb(241, 241, 241);
    min-height: 100vh;
  }

  .container-padding {
    padding: vw(0) vw(32);
  }
  .banner-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: vw(24);
    color: #fff;
    padding-bottom: vw(10);
    border-bottom: vw(2) solid #fff;
    margin-bottom: vw(6);
  }

  .serial-number {
    line-height: vw(50);
    font-family: DIN-Light;
    font-size: vw(40);
    letter-spacing: vw(2);
    color: #253e89;
    text-shadow: 0px vw(0) vw(0) #708fea, 0px vw(2) vw(0) #708fea,
      0px vw(4) vw(0) #7693eb;
    margin-bottom: vw(16);
  }
  .say-text-title {
    font-weight: 600;
  }
  .nutrition-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: vw(36);
  }

  .nutrition-text {
    font-family: PingFangSC-Semibold;
    font-size: vw(82);
    line-height: vw(114);
    color: #fff;
    margin-bottom: vw(4);
  }
  .stripe-code {
    height: vw(120);
    margin-right: vw(24);
  }
  .nutrition-title .desc {
    font-size: vw(24);
    color: #fff;
    line-height: vw(34);
  }

  .avatar-container {
    display: flex;
    align-items: center;
    font-size: vw(26);
    color: #fff;
    margin-bottom: vw(26);
  }

  .avatar-list {
    display: flex;
    align-items: center;
  }

  .avatar-container .avatar-item {
    width: vw(34);
    height: vw(34);
    border-radius: 50%;
    overflow: hidden;
    border: solid vw(4) #6385e8;
  }
  .avatar-item + .avatar-item {
    transform: translateX(-1.5vw);
  }
  .avatar-container .avatar-item .avatar-image {
    width: 100%;
    height: 100%;
  }
  .user-info {
    overflow: hidden;
    position: relative;
    background-color: #fff;
    border-radius: vw(12);
    padding: vw(30) vw(42);
    box-sizing: border-box;
    margin-bottom: vw(32);
  }

  .user-info .avatar {
    width: vw(98);
    height: vw(98);
    background-color: #d8d8d8;
    border-radius: vw(54);
    margin-right: vw(32);
  }

  .user-info .private-custom {
    position: absolute;
    top: vw(-36);
    right: vw(-24);
    width: vw(174);
    height: vw(174);
    z-index: 2;
  }

  .info-top {
    display: flex;
    align-items: center;
    margin-bottom: vw(26);
  }

  .user-info .user-name {
    font-size: vw(56);
    letter-spacing: vw(2);
    color: #202025;
  }

  .user-table {
    margin-bottom: vw(30);
  }

  .user-table .table-item {
    padding: vw(0) vw(36);
    box-sizing: border-box;
    height: vw(64);
    line-height: vw(64);
    font-size: vw(26);
    color: #202025;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .user-table .table-item:nth-child(2n + 1) {
    background-color: #f6f7f8;
  }

  .user-table .left,
  .user-table .right {
    width: 50%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .user-info .line {
    height: vw(4);
    background-color: #f2f2f2;
    margin-bottom: vw(40);
  }

  .user-info .target {
    display: flex;
    align-items: center;
    font-size: vw(40);
    color: #202025;
    margin-bottom: vw(10);
  }

  .user-info .dash-line {
    flex: 1;
    overflow: hidden;
    height: vw(0);
    border-bottom: vw(2) dashed #202025;
    margin: vw(0) vw(30) vw(0) vw(34);
  }

  .target-desc {
    font-size: vw(24);
    line-height: vw(38);
    color: #979da5;
    ::v-deep ul {
      display: block;
      list-style-type: disc;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
    }
  }
  .nav-container {
    position: sticky;
    width: 100%;
    z-index: 99;
    top: vw(20);
    padding: vw(0) vw(32);
    box-sizing: border-box;
  }
  .nav-list {
    height: vw(88);
    line-height: vw(88);
    background-color: #fff;
    border-radius: vw(44);
    display: flex;
    align-items: center;
    overflow: hidden;
    margin-bottom: vw(32);
  }

  .nav-item {
    box-sizing: border-box;
    width: vw(318);
    text-align: center;
    font-size: vw(32);
    color: #979da5;
  }

  .nav-item-active {
    width: vw(368);
    color: #fff;
    background-image: linear-gradient(90deg, #628df8 0%, #2755e0 100%);
    border-radius: vw(44);
  }

  .my-report {
    overflow: hidden;
    position: relative;
    padding: vw(40);
    padding-bottom: vw(0);
    box-sizing: border-box;
    background-color: #fff;
    border-radius: vw(12);
    margin-bottom: vw(32);
  }
  .v-flag {
    position: absolute;
    right: vw(0);
    top: vw(0);
    background-color: #6385e8;
    width: vw(200);
    height: vw(60);
    padding-bottom: vw(10);
    color: #fff;
    z-index: 2;
    display: flex;
    font-size: vw(24);
    align-items: flex-end;
    transform: translate(50%) rotate(45deg);
    transform-origin: center top;
    justify-content: center;
  }
  .flag-pink {
    background-color: #fa5a73;
  }
  .report-title {
    position: relative;
    font-size: vw(40);
    color: #202025;
    margin-bottom: vw(74);
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  .report-title .shadow {
    position: absolute;
    bottom: vw(0);
    left: vw(0);
    z-index: 0;
    width: vw(166);
    height: vw(18);
    background-image: linear-gradient(
      180deg,
      rgba(156, 186, 245, 0.1) 0%,
      #6384e8 100%
    );
  }
  .report-item {
    padding-bottom: vw(72);
  }
  .title-upline-top {
    position: relative;
    padding-top: vw(20);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: vw(50);
  }
  .title-upline-top::after {
    content: '';
    position: absolute;
    top: vw(0);
    left: vw(0);
    width: vw(84);
    height: vw(4);
    background-color: #202025;
  }

  .report-item .dashed-line {
    height: vw(0);
    flex: 1;
    overflow: hidden;
    border-bottom: vw(2) dashed #202025;
    margin-left: vw(38);
    margin-right: vw(28);
  }

  .bmi-content {
    margin-bottom: vw(44);
  }

  .bmi-desc {
    font-size: vw(24);
    line-height: vw(40);
    color: #979da5;
  }
  .habit-item .left {
    display: flex;
    align-items: center;
  }
  .habit-item {
    display: flex;
    align-items: center;
    font-size: vw(24);
    color: #202025;
    padding: vw(22) vw(32) vw(20);
    box-sizing: border-box;
  }
  .habit-list .habit-item:nth-child(2n + 1) {
    background-color: #f6f7f8;
  }
  .habit-item .icon {
    width: vw(32);
    height: vw(32);
    margin-right: vw(30);
    color: #979da5;
  }
  .habit-item .left {
    margin-right: vw(40);
  }
  .habit-item-center {
    max-width: vw(150);
  }
  .allergy-tips {
    font-size: vw(20);
  }
  .habit-item .right {
    text-align: right;
    flex: 1;
  }
  .food-tips {
    text-align: center;
    font-size: vw(24);
  }
  .nutrition-table {
    position: relative;
  }
  .nutrition-table-item {
    display: flex;
    align-items: center;
  }
  .nutrition-table-item .nutrition-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: vw(28);
  }
  .nutrition-table-item .nutrition-right {
    position: relative;
    flex: 1;
    overflow: hidden;
    min-height: vw(164);
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    border-left: vw(2) solid #d1d3d6;
    border-bottom: vw(2) solid #d1d3d6;
  }
  .nutrition-table-item .left-text {
    writing-mode: vertical-lr;
  }
  .left-dot {
    width: vw(20);
    height: vw(20);
    border-radius: 50%;
    background-color: #fa5a73;
    margin-bottom: vw(12);
  }
  .vertical-line-list {
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  .vertical-line-item {
    position: absolute;
    height: 100%;
    width: vw(2);
    background-color: #f2f2f2;
    top: vw(0);
    left: vw(0);
  }
  .nutrition-tag-item {
    width: vw(100);
    height: vw(100);
    padding: vw(6);
    box-sizing: border-box;
    text-align: center;
    overflow: hidden;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: vw(24);
    color: #fff;
    z-index: 2;
  }
  .nutrition-right .nutrition-tag-item:nth-child(4n) {
    margin-right: vw(0) !important;
  }
  .tag-big {
    background-image: linear-gradient(180deg, #fd93ab 0%, #fa5a73 100%);
  }
  .tag-middle {
    background-image: linear-gradient(180deg, #9cbaf5 0%, #6384e8 100%);
  }
  .tag-small {
    background-image: linear-gradient(180deg, #c8ccd1 0%, #979da5 100%);
  }
  .blue-line {
    width: vw(82);
    height: vw(6);
    background-color: #2a58e1;
    margin-bottom: vw(18);
  }
  .say-title {
    font-size: vw(32);
    color: #2a58e1;
    font-weight: 600;
    margin-bottom: vw(52);
  }
  .say-top {
    background-image: url('https://cdnvue.gymcity.com.cn/uploads/ff1be8d3eca3fba82b8c460f7e5e186e.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding: vw(22) vw(40) vw(10);
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .say-content {
    background-color: #f6f7f8;
    border-radius: vw(12);
    overflow: hidden;
  }
  .say-content .coach-avatar {
    width: vw(104);
    height: vw(104);
    border-radius: 50%;
    overflow: hidden;
    background-color: #d8d8d8;
    margin-bottom: vw(8);
  }
  .say-content .coach-info {
    margin-right: vw(44);
  }
  .say-content .coach-name {
    text-align: center;
    line-height: vw(44);
    font-size: vw(32);
    letter-spacing: vw(2);
    color: #fff;
  }
  .say-content .coach-desc {
    line-height: vw(32);
    font-size: vw(22);
    color: #fff;
  }
  .say-content .coach-desc-item {
    padding-left: vw(20);
    position: relative;
  }
  .say-content .coach-desc-item::after {
    position: absolute;
    content: '';
    width: vw(8);
    height: vw(8);
    border-radius: 50%;
    left: vw(0);
    top: vw(16);
    transform: translate(0%, -50%);
    background-color: #fff;
  }
  .say-content .say-text {
    overflow: hidden;
    padding: vw(28) vw(36) vw(0);
    box-sizing: border-box;
    font-size: vw(26);
    line-height: vw(44);
    color: #202025;
  }
  .say-text .say-text-item {
    margin-bottom: vw(24);
  }
  .say-text .say-text-item:last-child {
    margin-bottom: vw(0);
  }
  .say-content .open {
    text-align: center;
    padding-bottom: vw(20);
    font-size: vw(24);
    color: rgba(32, 32, 37, 0.5);
    margin-top: vw(10);
  }
  .say-content .open .iconfont {
    font-size: vw(20);
    margin-left: vw(8);
  }
  .say-open {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .say-content .rotate180 {
    transform: rotate(180deg);
  }
  .limit-text {
    max-height: vw(272);
    /* display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical; */
  }
  .nutrition-plan {
    overflow: hidden;
    position: relative;
    background-color: #fff;
    border-radius: vw(12);
    padding: vw(40) vw(42);
    box-sizing: border-box;
    margin-bottom: vw(32);
  }
  .nutrition-plan .shadow {
    background-image: linear-gradient(
      180deg,
      rgba(247, 222, 226, 0.1) 0%,
      #fa5a73 100%
    );
  }
  .nutrition-plan-desc {
    font-size: vw(24);
    color: rgba(32, 32, 37, 0.5);
  }
  .day-nav-list {
    width: 100%;
    margin-bottom: vw(52);
  }
  .food-content {
    margin-bottom: vw(80);
  }
  .food-content .content-list {
    margin-bottom: vw(52);
  }
  .food-content .content-list:last-child {
    margin-bottom: vw(0);
  }
  .food-content .meal-type {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: vw(26);
    color: #202025;
    height: vw(64);
    line-height: vw(64);
    background-color: #e6f8f5;
    padding: vw(0) vw(28);
    box-sizing: border-box;
  }
  .food-content .meal-type-1 {
    background-color: rgb(253, 240, 223);
  }
  .food-content .meal-type-2 {
    background-color: rgb(228, 234, 251);
  }
  .food-content .meal-type-3 {
    background-color: rgb(254, 233, 236);
  }
  .food-content .meal-text {
    font-size: vw(32);
    font-weight: 600;
    color: #202025;
  }
  .food-content .meal-item {
    line-height: vw(64);
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    padding: vw(0) vw(28);
    box-sizing: border-box;
  }
  .food-content .meal-list .meal-item:nth-child(2n + 1) {
    background-color: #f6f7f8;
  }
  .food-content .food-type {
    width: vw(136);
    font-size: vw(24);
    display: flex;
    align-items: flex-start;
    color: #979da5;
    margin-right: vw(20);
  }
  .food-content .food-list {
    flex-shrink: 0;
    overflow: hidden;
    font-size: vw(24);
    color: #000;
    margin-right: vw(20);
  }
  .meal-list .food-right {
    font-size: vw(24);
    flex: 1;
    overflow: hidden;
    flex-shrink: 0;
  }
  .meal-list .food-right-content {
    width: 100%;
  }
  .food-content .food-flex-1 {
    flex-shrink: 0;
    overflow: hidden;
    flex: 1;
    display: flex;
    align-items: center;
    margin-right: vw(20);
  }
  .meal-list .food-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .meal-list .food-name {
    margin-right: vw(20);
  }
  .food-content .food-left-content {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
  .food-content .food-right-line {
    width: vw(60);
    height: vw(0);
    border-bottom: vw(2) dashed #202025;
  }
  .food-content .food-unit {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: vw(24);
    color: #000;
  }
  .food-content .food-add-icon {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .food-content .food-line-icon {
    width: 100%;
    height: vw(0);
    margin-right: vw(20);
    border-bottom: vw(2) dashed #202025;
  }
  .food-content .food-add-item {
    box-sizing: border-box;
    width: 100%;
    height: vw(64);
    border-right: vw(2) dashed #202025;
    border-bottom: vw(2) dashed #202025;
  }
  .food-content .food-left-content .food-add-item:first-child {
    border-top-right-radius: vw(10);
    border-top: vw(2) dashed #202025;
  }
  .food-content .food-left-content .food-add-item:last-child {
    border-bottom-right-radius: vw(10);
  }
  .recommend {
    margin-top: vw(32);
    font-size: vw(24);
    color: #000;
  }
  .recommend-red {
    font-size: vw(24);
    color: #fa5a73;
    margin-right: vw(20);
    line-height: vw(30);
  }
  .drink-plan-title {
    font-size: vw(32);
    color: #202025;
    font-weight: 600;
  }
  .water-ml {
    display: flex;
    align-items: center;
    font-size: vw(24);
    color: #979da5;
    margin-left: vw(14);
  }
  .cup-image {
    height: vw(28);
  }
  .drink-time {
    font-size: vw(32);
    color: #202025;
    margin-bottom: vw(18);
    font-weight: 600;
  }
  .drink-day-item {
    margin-bottom: vw(52);
  }
  .dirnk-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: vw(12);
  }
  .drink-item-left {
    font-size: vw(26);
    color: #202025;
  }
  .drink-item-dashed {
    flex: 1;
    overflow: hidden;
    height: vw(0);
    border-bottom: vw(2) dashed #202025;
    margin-left: vw(16);
    margin-right: vw(20);
  }
  .drink-item-right {
    display: flex;
    align-items: center;
  }
  .drink-item-unit {
    font-size: vw(24);
    color: #000;
    margin-left: vw(18);
  }
  .drink-content {
    margin-bottom: vw(72);
  }
  .nitice-container {
    margin-bottom: vw(32);
  }
  .notice-iamge {
    width: 100%;
  }
  .reduce-fat-content {
    background-color: #9fb3ef;
    border-radius: vw(12);
    padding: vw(48) vw(32);
    box-sizing: border-box;
    margin-bottom: vw(32);
  }
  .reduce-fat-content .top-line {
    width: vw(98);
    height: vw(6);
    background-color: #fff;
    margin-bottom: vw(14);
  }
  .reduce-fat-content .title {
    font-size: vw(40);
    color: #fff;
    font-weight: 600;
  }
  .reduce-fat-content .desc {
    font-size: vw(26);
    color: #fff;
  }
  .reduce-fat-content .top-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: vw(22);
  }
  .reduce-fat-content .question-content {
    background-color: #fff;
    border-radius: vw(12);
    padding: vw(32) vw(32) vw(54);
    box-sizing: border-box;
  }
  .reduce-fat-content .question-image {
    width: 100%;
    margin-bottom: vw(20);
  }
  .reduce-fat-content .question-text {
    margin-bottom: vw(32);
  }
  .reduce-fat-content .btn-item {
    width: 100%;
    height: vw(88);
    background-color: #f2f2f2;
    border-radius: vw(44);
    margin-bottom: vw(20);
    text-align: center;
    line-height: vw(88);
    box-sizing: border-box;
  }
  .reduce-fat-content .btn-item-active {
    border: vw(2) solid #6384e8;
  }
  .reduce-fat-content .btn-list {
    margin-bottom: vw(32);
  }
  .reduce-fat-content .result {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .reduce-fat-content .result-text {
    font-size: vw(40);
    font-weight: 600;
    color: #202025;
  }
  .reduce-fat-content .iconfont {
    margin-right: vw(16);
    font-size: vw(42);
  }
  .reduce-fat-content .icon-kaixin {
    color: #43c572;
  }
  .reduce-fat-content .icon-nanguo {
    color: rgb(228, 58, 58);
  }
  .reduce-fat-content .line {
    width: 100%;
    height: vw(4);
    background-color: #f2f2f2;
    margin: vw(36) vw(0) vw(32);
  }
  .reduce-fat-content .parsing {
    font-size: vw(26);
    color: #202025;
    margin-bottom: vw(20);
  }
  .parsing-item {
    display: flex;
    align-items: flex-start;
    font-size: vw(24);
    line-height: vw(38);
    color: #202025;
  }
  .parsing-item-index {
    margin-right: vw(20);
  }
  .fat-camp-image {
    width: 100%;
  }
  .publicity-container {
    background-color: #ffd4cc;
  }
  .publicity-padding {
    padding: vw(32) vw(44);
    box-sizing: border-box;
  }
  .publicity-container .line-title-line {
    position: relative;
    font-size: vw(40);
    font-weight: 600;
    text-align: center;
    color: #000;
    margin-bottom: vw(32);
  }
  .publicity-container .line-title-line::before {
    position: absolute;
    content: '';
    left: vw(0);
    top: 50%;
    width: vw(210);
    height: vw(0);
    border-bottom: vw(2) dashed #202025;
  }
  .publicity-container .line-title-line::after {
    position: absolute;
    content: '';
    width: vw(210);
    height: vw(0);
    right: vw(0);
    top: 50%;
    border-bottom: vw(2) dashed #202025;
  }
  .testimonials-container,
  .case-container {
    background-color: #fff;
    border-radius: vw(12);
    padding: vw(60) vw(0) vw(74);
    box-sizing: border-box;
    margin-bottom: vw(32);
  }
  .swiper-dots {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: vw(32);
  }
  .swiper-dot-item {
    width: vw(10);
    height: vw(10);
    border-radius: 50%;
    background-color: #e9e9e9;
    margin: vw(0) vw(13);
  }
  .swiper-dot-item-active {
    background-color: #979da5;
  }
  .case-swiper {
    width: 100%;
    // height: vw(316);
    perspective: vw(2000);
    ::v-deep {
      .van-swipe__track {
        margin-left: vw(120);
      }
    }
  }
  .case-swiper-item {
    width: vw(448);
    // height: vw(316);
    overflow: hidden;
    border-radius: vw(12);
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      // width: 95%;
    }
  }
  .case-image {
    width: 100%;
    height: 100%;
    border-radius: vw(12);
  }
  .case-image-before {
    transform: translate(vw(20)) rotateY(-20deg) scale(0.8);
    transition: all 0.3s ease;
    opacity: 0.2;
  }
  .case-image-after {
    transform: translate(vw(-20)) rotateY(20deg) scale(0.8);
    transition: all 0.3s ease;
    opacity: 0.2;
  }
  .testimonials-swiper {
    height: vw(910);
  }
  .testimonials-swiper-item {
    width: 100%;
    height: 100%;
  }
  .testimonials-image {
    border-radius: vw(12);
    width: 100%;
    height: 100%;
  }
  .testimonials-image-before {
    transform: translate(vw(0)) rotateY(-20deg) scale(0.8);
    transition: all 0.3s ease;
    opacity: 0.2;
  }
  .testimonials-image-after {
    transform: translate(vw(0)) rotateY(20deg) scale(0.8);
    transition: all 0.3s ease;
    opacity: 0.2;
  }
  .bottom-content {
    background-color: #fff;
    padding: vw(120) vw(88);
    box-sizing: border-box;
  }
  .qrcode-content {
    margin: 0 auto;
    margin-bottom: vw(32);
    width: vw(408);
    height: vw(408);
    background-color: #f0f0f0;
    border-radius: vw(12);
    padding: vw(20);
    box-sizing: border-box;
  }
  .qrcode-image {
    width: 100%;
    height: 100%;
  }
  .qrcode-center {
    text-align: center;
    line-height: vw(60);
    border-bottom: vw(2) solid #f2f2f2;
    margin-bottom: vw(60);
    padding-bottom: vw(50);
    font-size: vw(40);
    color: #000;
  }
  .qrcode-center .iconfont {
    margin-bottom: vw(26);
    font-size: vw(40);
  }
  .feedback-btn {
    height: vw(88);
    line-height: vw(88);
    text-align: center;
    color: #fff;
    background-image: linear-gradient(90deg, #618cf7 0%, #3562e5 100%);
    border-radius: vw(44);
    margin-bottom: vw(20);
  }
  .feedback-text {
    text-align: center;
    font-size: vw(26);
    color: #979da5;
  }
  .feedback-tip {
    padding: vw(0) vw(12);
    height: vw(40);
    font-size: vw(26);
    line-height: vw(40);
    background-color: rgb(254, 236, 239);
    color: #fa5a73;
    margin-left: vw(8);
  }
  .diagnosis-content {
    background-color: #fef1e8;
    border-radius: vw(12);
    padding: vw(32) vw(40) vw(52);
    box-sizing: border-box;
  }
  .diagnosis-content .title {
    font-family: PingFangSC-Medium;
    font-size: vw(32);
    font-weight: 600;
    color: #903836;
    margin-bottom: vw(16);
  }
  .diagnosis-content .desc {
    font-family: PingFangSC-Regular;
    font-size: vw(26);
    line-height: vw(44);
    color: #903836;
  }
  .diagnosis-content .desc .bold {
  }
  .diagnosis-content .code {
    display: block;
    width: vw(312);
    height: vw(312);
    margin: vw(36) auto vw(44) auto;
  }
  .diagnosis-content .tips {
    text-align: center;
    position: relative;
    padding: vw(16) vw(40);
    box-sizing: border-box;
    background-color: #fff;
    box-shadow: 0px -vw(4) vw(12) vw(0) rgba(144, 56, 54, 0.04);
    border-radius: vw(12);
    font-family: PingFangSC-Medium;
    font-size: vw(26);
    line-height: vw(42);
    font-weight: 600;
    color: #000000;
  }
  .diagnosis-content .tips .circle {
    position: absolute;
    width: 0;
    height: 0;
    border-bottom: vw(20) solid #fff;
    border-top: none;
    border-left: vw(20) solid transparent;
    border-right: vw(20) solid transparent;
    left: 50%;
    top: -vw(20);
    transform: translate(-50%);
  }
}
</style>